import React from 'react';

const Analytics = ({ analytics }) => {
  const totalSignups = analytics.reduce((sum, city) => sum + city.count, 0);
  const totalConfirmed = analytics.reduce((sum, city) => sum + city.confirmed, 0);
  const totalWaitlist = analytics.reduce((sum, city) => sum + city.waitlist, 0);

  return (
    <div className="space-y-12" data-testid="analytics-section">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="border border-border p-8">
          <p className="caption-text text-muted-foreground mb-2">TOTAL SIGNUPS</p>
          <p className="text-5xl font-heading font-bold" data-testid="total-signups">{totalSignups}</p>
        </div>
        <div className="border border-border p-8">
          <p className="caption-text text-muted-foreground mb-2">CONFIRMED</p>
          <p className="text-5xl font-heading font-bold text-primary" data-testid="total-confirmed">{totalConfirmed}</p>
        </div>
        <div className="border border-border p-8">
          <p className="caption-text text-muted-foreground mb-2">WAITLIST</p>
          <p className="text-5xl font-heading font-bold text-accent" data-testid="total-waitlist">{totalWaitlist}</p>
        </div>
      </div>

      {/* City Breakdown */}
      <div>
        <h2 className="section-title text-3xl mb-6">CITY BREAKDOWN</h2>
        <div className="space-y-6">
          {analytics.map((city) => (
            <div key={city.city} className="border border-border p-6" data-testid={`city-stats-${city.city.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                  <h3 className="font-heading text-2xl font-bold uppercase mb-2">{city.city}</h3>
                  <p className="text-muted-foreground">Total Signups: {city.count}</p>
                </div>
                <div className="flex gap-8">
                  <div>
                    <p className="caption-text text-muted-foreground mb-1">CONFIRMED</p>
                    <p className="text-3xl font-heading font-bold">{city.confirmed}</p>
                  </div>
                  <div>
                    <p className="caption-text text-muted-foreground mb-1">WAITLIST</p>
                    <p className="text-3xl font-heading font-bold text-accent">{city.waitlist}</p>
                  </div>
                </div>
              </div>
              
              {/* Progress Bar */}
              {city.count > 0 && (
                <div className="mt-4">
                  <div className="h-2 bg-secondary overflow-hidden">
                    <div
                      className="h-full bg-primary transition-all duration-500"
                      style={{ width: `${(city.confirmed / city.count) * 100}%` }}
                    />
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">
                    {Math.round((city.confirmed / city.count) * 100)}% confirmed
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Analytics;